import axios from './axiosInstance';
export const getUserDetails = ()=>{
  return axios.get(`/define/api/user/details`);
}

export const getStudiesByUserId = (userId,pageNum,pageSize,myWorklist)=>{
  return axios.get(`/define/study/detail/user/${userId}?pageNum=${pageNum}&pageSize=${pageSize}${myWorklist ? '&myWorklist=true' : ''}`);
}


export const getStudyByStudyId = (studyId)=>{
  return axios.get(`/define/study/detail/studyid/${studyId}`);
}

export const getDefineDropdownValues = ()=>{
  return axios.get(`/define/standard/define`);
}

export const getCDISCStandardDropdownValues = ()=>{
  return axios.get(`/define/standard/cdisc`);
}


export const getCDISCStdVersionDropdownValues = (version)=>{
  return axios.get(`/define/standard/version/${version}`);
}

export const getDropdownValues = ()=>{
  return axios.get(`/define/dictionary/all`);
}

export const getCTNameDropdownValues = ()=>{
  return axios.get(`/define/ct/name`);
}

export const getCTNameVersionDropdownValues = (referenceKey)=>{
  return axios.get(`/define/ct/version/${referenceKey}`);
}

export const createStudy = (data)=>{
  return axios.post(`/define/study/create`, data, {
    headers: {
      'Content-Type': undefined,
    },
  });
}
export const updateStudy = (data,studyId)=>{
return axios.post(`/define/study/update/${studyId}`, data, {
    headers: {
      'Content-Type': undefined,
    },
  });
}
export const createStudyGroup = (data)=>{
  return axios.post(`/define/studygroup/create`,data);
}
export const getStudygroupDetails = (data)=>{
  return axios.get(`/define/studygroup/details`);
}


export const deleteFile = (studyField,userId)=>{
  return axios.get(`/define/file/delete/${studyField}/${userId}`);
}

export const uploadFile = (studyId, userId, formData) => {
  return axios.post(`/define/file/upload/${userId}/${studyId}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}

export const getFileDetails = (studyId)=>{
  return axios.get(`/define/file/details/${studyId}`);
}

export const saveXptFile = (userId, studyId, filesData) => {
  return axios.post(`/define/file/update/${userId}/${studyId}`, filesData);
}

export const getglobalVariables = ()=>{
  return axios.get(`/define/vlm/global/variables`);
}

export const getDataSets = (studyId, defineVersion = '')=>{
  return axios.get(`/define/file/datasets/xptVariables?studyId=${studyId}&defineVersion=${defineVersion}`);
}

export const saveStudyVariables = (data) => {
  return axios.post(`/define/vlm/save/study/variables`, data);
}

export const generateDefine = (studyId) => {
  return axios.post(`/define/api/define/generate?studyId=${studyId}`);
}

export const reGenerateDefine = (studyId) => {
  return axios.post(`/define/api/define/re-generate?studyId=${studyId}`);
}

export const defineHistory = (studyId) => {
  return axios.post(`/define/api/define/history?studyId=${studyId}`);
}


export const downloadDefine = (studyId,versionNumber,revisionNumber,format) => {
  return axios.get(`/define/api/define/download?studyId=${studyId}&versionNumber=${versionNumber}&revisionNumber=${revisionNumber}&format=${format}`);
}


export const getsavedStudyVariables = (studyId, defineVersion = 1)=>{
  return axios.get(`/define/vlm/get/study/variables?studyId=${studyId}&defineVersion=${defineVersion}`);
}


export const getExcelView = (revisionNumber)=>{
  return axios.get(`/excel-to-json/api/excel/json/${revisionNumber}`);
}

export const getSaveUpdateDelete = (payload)=>{
  return axios.post(`/excel-to-json/api/excel/records/save`, payload);
}

export const getWorkList = (studyId)=>{
  return axios.get(`/define/study/addToWorklist/${studyId}`);
}